<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dgigVb/tc-custom/9780061990205.jpg?1718106104314" alt="This image is the cover for the book Paul Was Not a Christian"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Paul Was Not a Christian
      </h1>
      <p class="bookDescription body article font2">
        <p>Pamela Eisenbaum, an expert on early Christianity, reveals the true nature of the historical Paul in <i>Paul Was Not a Christian. </i>She explores the idea of Paul not as the founder of a new Christian religion, but as a devout Jew who believed Jesus was the Christ who would unite Jews and Gentiles and fulfill God’s universal plan for humanity. Eisenbaum’s work in <i>Paul Was Not a Christian </i> will have a profound impact on the way many Christians approach evangelism and how to better follow Jesus’s—and Paul’s—teachings on how to live faithfully today.<b><i></i></b></p><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Pamela Eisenbaum
      </h2>
      
      <p class="authorDescription body article"><P>Pamela Eisenbaum is the associate professor of biblical studies and Christian origins at Iliff School of Theology in Denver, Colorado. Eisenbaum is a national media expert on early Christianity and, as a practicing Jew teaching in a Christian seminary, has a unique perspective on the origins of Christianity.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      HarperCollins
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09fe2b36